// Function that returns a promise resolving when a specified property is set on an object
export default function whenPropertyIsSet(target, prop, timeout) {
    if (timeout === void 0) timeout = 0;
    var _originalDescriptor, _originalDescriptor1;
    if (!(target !== null && typeof target === "object")) {
        throw new Error("Target must be an object");
    }
    // Resolve immediately if the property already exists
    if (typeof target[prop] !== "undefined") {
        return Promise.resolve(target[prop]);
    }
    // Get the original descriptor of the property
    // Docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyDescriptor
    var originalDescriptor = Object.getOwnPropertyDescriptor(target, prop);
    // Resolve immediately if the property is not configurable or writable
    if (((_originalDescriptor = originalDescriptor) == null ? void 0 : _originalDescriptor.configurable) === false || ((_originalDescriptor1 = originalDescriptor) == null ? void 0 : _originalDescriptor1.writable) === false) {
        return Promise.resolve(target[prop]);
    }
    // Return a promise that resolves when the property is set
    var promises = [
        new Promise(function(resolve) {
            var _originalDescriptor;
            var _originalDescriptor_enumerable;
            // Define a new property descriptor that resolves the promise when set
            // Docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
            Object.defineProperty(target, prop, {
                configurable: true,
                enumerable: (_originalDescriptor_enumerable = (_originalDescriptor = originalDescriptor) == null ? void 0 : _originalDescriptor.enumerable) != null ? _originalDescriptor_enumerable : true,
                get: function() {
                    var _originalDescriptor, _originalDescriptor1;
                    // Maintain the original getter if it exists
                    if ((_originalDescriptor = originalDescriptor) == null ? void 0 : _originalDescriptor.get) {
                        return originalDescriptor.get.call(this);
                    } else if ((_originalDescriptor1 = originalDescriptor) == null ? void 0 : _originalDescriptor1.hasOwnProperty("value")) {
                        return originalDescriptor.value;
                    }
                    return undefined;
                },
                set: function(value) {
                    if (originalDescriptor) {
                        // Restore the original property descriptor and set the value
                        Object.defineProperty(target, prop, originalDescriptor);
                        target[prop] = value;
                    } else {
                        // Define a new property with the given value
                        Object.defineProperty(target, prop, {
                            value: value,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                    }
                    resolve(value);
                }
            });
        })
    ];
    // If a timeout is provided, add a timeout promise
    if (timeout > 0) {
        promises.push(new Promise(function(_, reject) {
            setTimeout(function() {
                reject(new Error("Property " + prop + " was not set within " + timeout + "ms"));
            }, timeout);
        }));
    }
    return Promise.race(promises);
}

//# sourceMappingURL=whenPropertyIsSet.js.map